import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useControls } from "src/utils/createControls";
import { usePurchaseContext } from "src/modules/purchase/PurchaseContext";
import { isFreemium } from "src/modules/auth/duck/selectors";
import { getAvatars } from "src/modules/avatar/duck/selectors";
import Dialog from "src/components/Dialog";
import Cards from "./Cards";

function MultiStationPicker({
  isConnecting,
  onConnect,
  stations = [],
  isInModal
}) {
  const [listedStations, setListedStations] = useState([]);
  const [selectedStations, setSelectedStations] = useState([]);
  const warning = useControls();
  const refs = useRef({});

  const isFreeVersion = useSelector(isFreemium);

  const { t } = useTranslation();
  const purchase = usePurchaseContext();

  const avatars = Object.values(useSelector(getAvatars)).filter(
    (avatar) => !avatar.deleted
  );

  const StationSelect = {
    add(jid) {
      setSelectedStations((prev) => [...prev, jid]);
    },
    remove(jid) {
      const update = selectedStations.filter((id) => id !== jid);
      setSelectedStations(update);
    }
  };

  function handleAvatarChange(stationId, avatarId) {
    const updatedStation = { ...listedStations[stationId] };
    updatedStation.avatarId = avatarId;
    const newStations = [...listedStations];
    newStations[stationId] = updatedStation;
    setListedStations(newStations);
  }

  function handleConnect(stations) {
    if (isFreeVersion && stations && stations.length > 1) {
      purchase.open({ content: "multibaby" });
      return;
    }
    if (stations && stations.length > 4) {
      warning.open();
      return;
    }
    onConnect(stations);
  }

  useEffect(() => {
    if (isConnecting) return;
    stations.forEach((station, i) => {
      const stationInCurrentList = listedStations.filter(
        (listedStation) => listedStation === station
      )[0];
      if (stationInCurrentList) return;
      else StationSelect.add(station.jid);
    });

    selectedStations.forEach((stationId, i) => {
      const hasReference = stations.filter((ref) => ref.jid === stationId)[0];
      if (!hasReference) StationSelect.remove(stationId);
    });
    setListedStations(stations);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stations]);

  return (
    <>
      <Cards
        StationSelect={StationSelect}
        handleAvatarChange={handleAvatarChange}
        handleConnect={handleConnect}
        selectedStations={selectedStations}
        listedStations={listedStations}
        isConnecting={isConnecting}
        isInModal={isInModal}
        avatars={avatars}
        refs={refs}
        t={t}
      />
      <Dialog
        isOpen={warning.isOpen}
        onDismiss={warning.close}
        type="warning"
        heading={t("parentStation.stationSelect.connectionLimit.heading")}
        text={t("parentStation.stationSelect.connectionLimit.text")}
        buttons={[
          {
            text: t("buttons.ok"),
            onClick: warning.close
          }
        ]}
      />
    </>
  );
}

export default MultiStationPicker;
